import AuthManager from "Common/AuthManager";
import ServiceWrapper from "Services/ServiceWrapper";
import AppSettings from "Settings/AppSettings";

const api_base_url = AppSettings.GMS_BACKEND_API_URL;

export const getMerchantsBasedOnPartyAndIndustry = async (partyId: string, industryId: string) => {
    try {
        const response = await ServiceWrapper.doGet(
            `${api_base_url}user/channel/party/${partyId}/industry/${industryId}`,
            null,
            null,
            AuthManager.getGmsToken()
        );
        return response;
    } catch(error) {
        console.log(error);
        return null;
    }
};